
import { Component, Vue, Watch } from "vue-property-decorator";
import { API_INVOICE_LIST, API_INVOICE_EXPORT } from "@/configs/Apis";
import DContainerLayout from "../base/DContainerLayout.vue";
import ModifyInvoice from "./subviews/ModifyInvoice.vue";
import DList from "@/views/base/DList.vue";
import { Fetcher } from "@/utils/Request";
import { isEmpty, isEmptyOrWhiteSpace, showError, showSuccess, showWarning } from "@/utils/Common";
import { MSG_ADD_SUCCESS, MSG_EXPORT_FILE_NOTFOUND, MSG_INVALID_PAGE, MSG_MODIFY_SUCCESS, MSG_DELETE_SUCCESS, MSG_001, AGENCY_INVOICE_ID } from "@/configs/Consts";

import { MessageBox } from "element-ui";

import { Tooltip } from "element-ui";

Vue.use(Tooltip);

@Component({
  components: { DList, DContainerLayout, ModifyInvoice }
})
export default class Invoice extends Vue {
  queryStr: string = "";

  queryData: any = {
    title: ""
  };

  invoiceItem: any = {};

  addInvoiceDialogVisible: boolean = false;

  showSearch: boolean = false;

  get searchBtnIcon(): string {
    return this.showSearch ? "el-icon-arrow-up" : "el-icon-arrow-down";
  }

  get dataApi() {
    return API_INVOICE_LIST;
  }

  isEditInvoice() {
    return this.invoiceItem && !isEmpty(this.invoiceItem.id);
  }

  createTableColumns() {
    const columns: Array<TableColumnOption> = [
      {
        prop: "asDefault",
        display: "默认",
        width: 80,
        formatter: (data: any, column: any, value: any) => `${value === true ? "是" : ""}`
      },
      { prop: "title", display: "发票抬头", width: 220 },
      { prop: "taxNo", display: "税务登记证号", width: 160 },
      { prop: "bank", display: "开户银行", width: 160 },
      { prop: "bankNo", display: "开户银行账号" },
      { prop: "address", display: "注册地址" },
      { prop: "phone", display: "联系电话", width: 120 }
    ];
    this.$store.dispatch("invoicemanager/setColumns", columns);
  }

  editInvoice() {
    const selectedRows = (this.$refs.invoicegrid as any).getSelectedDataRows();
    if (!selectedRows || !selectedRows.length) {
      showWarning(MSG_001);
      return;
    }
    const row = selectedRows[0];
    if (isEmpty(row)) {
      return;
    }
    if (row.id === AGENCY_INVOICE_ID) {
      showWarning("系统数据不允许修改");
      return;
    }
    const fields = ["id", "title", "taxNo", "bank", "bankNo", "address", "phone", "asDefault"],
      newItem: { [key: string]: any } = {};

    fields.forEach(name => newItem[name] = row[name]);
    this.invoiceItem = newItem;
    this.addInvoiceDialogVisible = true;
  }

  deleteInvoice() {
    const selectedRows = (this.$refs.invoicegrid as any).getSelectedDataRows();
    if (!selectedRows || !selectedRows.length) {
      showWarning(MSG_001);
      return;
    }
    const row = selectedRows[0];
    if (isEmpty(row)) {
      return;
    }
    if (row.id === AGENCY_INVOICE_ID) {
      showWarning("系统数据不允许删除");
      return;
    }
    MessageBox.confirm(`此操作将彻底删除: ${row.title}, 是否继续?`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      this.$store.dispatch("invoicemanager/deleteInvoice", row.id)
        .then(() => {
          this.doSearch();
          showSuccess(MSG_DELETE_SUCCESS);
        })
        .catch(({ message }) => showError(message));
    }).catch(() => {
    });
  }

  onQueryChanged() {
    this.queryStr = JSON.stringify(this.queryData);
  }

  doSearch() {
    this.queryStr += " ";
  }

  newInvoice() {
    this.invoiceItem = {};
    this.addInvoiceDialogVisible = true;
  }

  exportData(cmd: string) {
    let params: any = {};
    if (cmd === "selected") {
      const selectedRows = (this.$refs.invoicegrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }

      params.selectedIds = selectedRows;
    } else {
      if (!isEmptyOrWhiteSpace(this.queryStr)) {
        params = JSON.parse(this.queryStr);
      }
    }
    Fetcher.queryData(API_INVOICE_EXPORT, params).then(url => {
      if (isEmpty(url)) {
        showWarning(MSG_EXPORT_FILE_NOTFOUND);
        return;
      }
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("target", "_blank");
      document.body.appendChild(a);
      a.click();
      if (a.parentNode) {
        a.parentNode.removeChild(a);
      }
    }).catch(({ message }) => showError(message));
  }

  onDialogClose() {
    this.invoiceItem = {};
  }

  onSaveSuccess() {
    this.doSearch();
    this.addInvoiceDialogVisible = false;
    this.invoiceItem = {};
  }
}
